module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.rootCss],
    style: (_vm.rootStyle)
  }, [(_vm.loading) ? _c('table', {
    class: [(_vm.rootCss + "-grid")],
    style: (_vm.style),
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.title || _vm.description) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.setup.strings.length
    }
  }, [(_vm.title) ? _c('h5', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.notes) ? _c('tr', {
    class: [(_vm.rootCss + "-small-caps"), (_vm.rootCss + "-notes"), (_vm.rootCss + "-greyed-out")]
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.setup.tuning), function(key) {
    return _c('td', [_vm._v(_vm._s(key))])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.frets), function(fret, index) {
    return _c('tr', {
      key: index,
      class: [(_vm.rootCss + "-small-caps"), (_vm.rootCss + "-neck")]
    }, [_c('td', {
      class: ['vc-chord-diagram-position', (_vm.rootCss + "-greyed-out")]
    }, [(_vm.position) ? _c('div', [_vm._v(_vm._s(_vm.romanize(_vm.setup.startAt + index)))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.setup.strings), function(string) {
      return _c('td', {
        style: ({
          borderBottomColor: ("" + _vm.color)
        })
      }, [_c('div', [(string.fret === fret) ? _c('div', {
        class: [(_vm.rootCss + "-finger")],
        style: (_vm.dot)
      }) : _c('div', {
        class: [(_vm.rootCss + "-finger")],
        style: (_vm.empty)
      })]), _vm._v(" "), _c('div', {
        style: ({
          background: _vm.color
        })
      })])
    })], 2)
  }), _vm._v(" "), (_vm.fingers) ? _c('tr', {
    class: [(_vm.rootCss + "-fingers"), (_vm.rootCss + "-small-caps"), (_vm.rootCss + "-greyed-out")]
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.setup.strings), function(string) {
    return _c('td', {
      domProps: {
        "innerHTML": _vm._s(string.finger)
      }
    })
  })], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.canvas) ? _c('img', {
    style: (_vm.style),
    attrs: {
      "src": _vm.src
    },
    on: {
      "load": _vm.ready
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1184c074","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-chord-diagram/index.vue
// module id = 104
// module chunks = 2